/* eslint-disable fp/no-mutation */
import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {AxiosResponse} from 'axios'
import {ServerCode} from 'services/psd2/types'
import {LinkType} from '@daedalus/core/src/booking/types/Link'
import {BookStateType, initialState} from './reducer'
import {BookingRequest} from '@daedalus/core/src/booking/types/BookingRequest'
import {BookingCreationResponse} from '@daedalus/core/src/booking/types/BookingCreationResponse'
import {BookingStatus} from '@daedalus/core/src/booking/types/BookingStatus'

const setCurrentModuleState = (
  state: BookStateType,
  action: PayloadAction<string>
) => {
  state.offerBookState = action.type
}

interface BookOfferCreationAction {
  link: LinkType
  payload: BookingRequest
  providerCode: string
  serverCode: ServerCode
}

const {actions, reducer} = createSlice({
  name: 'book',
  initialState,
  reducers: {
    bookOfferCreation: (
      state: BookStateType,
      action: PayloadAction<BookOfferCreationAction>
    ) => {
      state.offerBookState = action.type
    },
    bookOfferCreationPending: setCurrentModuleState,
    bookOfferCreationDone: (
      state: BookStateType,
      action: PayloadAction<AxiosResponse<BookingCreationResponse>>
    ) => {
      state.offerBookState = action.type
      state.booking.id = action.payload?.data?.id
      state.booking.status = BookingStatus.INITIALIZED
    },
    bookOfferCreationError: setCurrentModuleState,
    bookOfferCreationFatalError: setCurrentModuleState,
    bookOfferCreationConfirm: (
      state: BookStateType,
      action: PayloadAction<Partial<BookingCreationResponse>>
    ) => {
      state.booking.status = BookingStatus.CONFIRMED
      state.offerBookState = action.type
    }
  }
})

export const {
  bookOfferCreation,
  bookOfferCreationPending,
  bookOfferCreationDone,
  bookOfferCreationError,
  bookOfferCreationFatalError,
  bookOfferCreationConfirm
} = actions

export default reducer
